import {get} from 'components/api';
import {validCourses} from 'constants/url';

async function getCoursesByProfile(
  iD_Profile: number,
  iD_Sector: number,
  token: string,
) {
  const url = `${validCourses}?ID_Profile=${iD_Profile}&ID_Sector=${iD_Sector}`;
  return get(url, token);
}

export default getCoursesByProfile;
